import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Trophy } from "lucide-react";

export default function ShowroomRankCard() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/dealers/portal/showroom-rank").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r) return null;
  return (
    <div className="rounded-2xl border border-amber-400/30 bg-amber-400/5 p-4 flex items-center gap-4" data-testid="showroom-rank-card">
      <span className="w-12 h-12 rounded-xl bg-amber-400/15 flex items-center justify-center"><Trophy className="w-6 h-6 text-amber-300" /></span>
      <div className="flex-1">
        {r.rank ? <p className="font-semibold" data-testid="showroom-rank-text">You're <span className="font-mono text-amber-300">#{r.rank}</span> of {r.total} showrooms this month · {r.scans} scans</p> : <p className="font-semibold" data-testid="showroom-rank-text">Not ranked yet — get your first TV scan to join the board</p>}
        <p className="text-xs text-slate-400 mt-0.5">{r.rank === 1 ? "You're leading the whole network." : r.gap ? `${r.gap} more scans to pass the showroom ahead of you.` : r.leader ? `${r.leader} leads the network.` : ""}{!r.public && " Hidden from the public board."}</p>
      </div>
      <Link to="/showrooms/leaderboard" className="text-xs font-semibold text-amber-300 hover:underline" data-testid="showroom-rank-link">See board →</Link>
    </div>
  );
}
